import { createEnvelopeSource } from './create-envelope-source';
import { DOC31_EDITION_ID } from './doc31-edition';

/**
 * Coupons of one 31DOC edition (`GET /analytics/coupons-31doc`): issued by
 * door openings, and redeemed in store. Both count for the participation that
 * won the coupon, so a gifted coupon still counts where it was won. Never
 * summed with the RPP coupon sources.
 */
export const coupons31docSource = createEnvelopeSource({
    label: '31DOC coupons',
    endpoint: 'analytics/coupons-31doc',
    metrics: [
        {
            id: 'couponsIssued31doc',
            label: '31DOC coupons issued',
            type: 'scalar',
        },
        {
            id: 'couponsRedeemed31doc',
            label: '31DOC coupons redeemed',
            type: 'scalar',
        },
    ],
    forms: ['number', 'bars', 'pie'],
    regionGrain: 'province',
    staticParams: { campaignId: DOC31_EDITION_ID },
});
